export class PERequest {
  public userdata: UserData;
  public requestparam: RequestParam;

  populateUserData(contentjson?: any) {
    if (this.userdata === null || this.userdata === undefined) {
      this.userdata = new UserData();
    }
    if (contentjson) {
      if (contentjson['MQMBalance']) {
        this.userdata.MQMBalance = contentjson['MQMBalance'];
      }
      if (contentjson['authenticated']) {
        this.userdata.authenticated = contentjson['authenticated'];
      }
      if (contentjson['cartCnt']) {
        this.userdata.cartCnt = contentjson['cartCnt'];
      }
      if (contentjson['cartID']) {
        this.userdata.cartID = contentjson['cartID'];
      }
      if (contentjson['country']) {
        this.userdata.country = contentjson['country'];
      }
      if (contentjson['crprtAgrmntFound']) {
        this.userdata.crprtAgrmntFound = contentjson['crprtAgrmntFound'];
      }
      if (contentjson['customerID']) {
        this.userdata.customerID = contentjson['customerID'];
      }
      if (contentjson['displayPwdWarning']) {
        this.userdata.displayPwdWarning = contentjson['displayPwdWarning'];
      }
      if (contentjson['enrollmentDate']) {
        this.userdata.enrollmentDate = contentjson['enrollmentDate'];
      }
      if (contentjson['errorCd']) {
        this.userdata.errorCd = contentjson['errorCd'];
      }
      if (contentjson['firstName']) {
        this.userdata.firstName = contentjson['firstName'];
      }
      if (contentjson['firstTime']) {
        this.userdata.firstTime = contentjson['firstTime'];
      }
      if (contentjson['formNameSubmitted']) {
        this.userdata.formNameSubmitted = contentjson['formNameSubmitted'];
      }
      if (contentjson['hasEmail']) {
        this.userdata.hasEmail = contentjson['hasEmail'];
      }
      if (contentjson['hasError']) {
        this.userdata.hasError = contentjson['hasError'];
      }
      if (contentjson['hasPW']) {
        this.userdata.hasPW = contentjson['hasPW'];
      }
      if (contentjson['hasSQA']) {
        this.userdata.hasSQA = contentjson['hasSQA'];
      }
      if (contentjson['hasUserNm']) {
        this.userdata.hasUserNm = contentjson['hasUserNm'];
      }
      if (contentjson['irop']) {
        this.userdata.irop = contentjson['irop'];
      }
      if (contentjson['is360Tier']) {
        this.userdata.is360Tier = contentjson['is360Tier'];
      }
      if (contentjson['langPromptIndicator']) {
        this.userdata.langPromptIndicator = contentjson['langPromptIndicator'];
      }
      if (contentjson['language']) {
        this.userdata.language = contentjson['language'];
      }
      if (contentjson['lastName']) {
        this.userdata.lastName = contentjson['lastName'];
      }
      if (contentjson['loggedIn']) {
        this.userdata.loggedIn = contentjson['loggedIn'];
      }
      if (contentjson['loyaltyPromoInd']) {
        this.userdata.loyaltyPromoInd = contentjson['loyaltyPromoInd'];
      }
      if (contentjson['loyaltyPromoLink']) {
        this.userdata.loyaltyPromoLink = contentjson['loyaltyPromoLink'];
      }
      if (contentjson['medallionMbrInd']) {
        this.userdata.medallionMbrInd = contentjson['medallionMbrInd'];
      }
      if (contentjson['medallionMemberDesc']) {
        this.userdata.medallionMemberDesc = contentjson['medallionMemberDesc'];
      }
      if (contentjson['membershipLevel']) {
        this.userdata.membershipLevel = contentjson['membershipLevel'];
      }
      if (contentjson['middleName']) {
        this.userdata.middleName = contentjson['middleName'];
      }
      if (contentjson['millionMiler']) {
        this.userdata.millionMiler = contentjson['millionMiler'];
      }
      if (contentjson['millionMilerTier']) {
        this.userdata.millionMilerTier = contentjson['millionMilerTier'];
      }
      if (contentjson['nameSuffix']) {
        this.userdata.nameSuffix = contentjson['nameSuffix'];
      }
      if (contentjson['preferredName']) {
        this.userdata.preferredName = contentjson['preferredName'];
      }
      if (contentjson['prefix']) {
        this.userdata.prefix = contentjson['prefix'];
      }
      if (contentjson['primaryEmailAddress']) {
        this.userdata.primaryEmailAddress = contentjson['primaryEmailAddress'];
      }
      if (contentjson['promoCdInd']) {
        this.userdata.promoCdInd = contentjson['promoCdInd'];
      }
      if (contentjson['pwmMbr']) {
        this.userdata.pwmMbr = contentjson['pwmMbr'];
      }
      if (contentjson['rememberMeFirstName']) {
        this.userdata.rememberMeFirstName = contentjson['rememberMeFirstName'];
      }
      if (contentjson['rememberMeID']) {
        this.userdata.rememberMeID = contentjson['rememberMeID'];
      }
      if (contentjson['rememberMeIndicator']) {
        this.userdata.rememberMeIndicator = contentjson['rememberMeIndicator'];
      }
      if (contentjson['rememberMeLastName']) {
        this.userdata.rememberMeLastName = contentjson['rememberMeLastName'];
      }
      if (contentjson['skyPriority']) {
        this.userdata.skyPriority = contentjson['skyPriority'];
      }
      if (contentjson['skymilesMember']) {
        this.userdata.skymilesMember = contentjson['skymilesMember'];
      }
      if (contentjson['smBalance']) {
        this.userdata.smBalance = contentjson['smBalance'];
      }
      if (contentjson['smNumber']) {
        this.userdata.smNumber = contentjson['smNumber'];
      }
      if (contentjson['spgInd']) {
        this.userdata.spgInd = contentjson['spgInd'];
      }
      if (contentjson['sysDrvdPrefHomeArptCd']) {
        this.userdata.sysDrvdPrefHomeArptCd =
          contentjson['sysDrvdPrefHomeArptCd'];
      }
      if (contentjson['usernameType']) {
        this.userdata.usernameType = contentjson['usernameType'];
      }
      if (contentjson['usrProvdPrefHomeArptCd']) {
        this.userdata.usrProvdPrefHomeArptCd =
          contentjson['usrProvdPrefHomeArptCd'];
      }
      if (contentjson['venderID']) {
        this.userdata.venderID = contentjson['venderID'];
      }
      // if (contentjson['v01']) {
      //   this.userdata.mbDerivedHomeAirportCode = contentjson['v01'];
      // }
      // if (contentjson['v02']) {
      //   this.userdata.mbCountryCode = contentjson['v02'];
      // }
      // if (contentjson['v03']) {
      //   this.userdata.mbActionIndicator = contentjson['v03'];
      // }
      // if (contentjson['v07']) {
      //   this.userdata.mbSMTireLevel = contentjson['v07'];
      // }
      // if (contentjson['v08']) {
      //   this.userdata.mbStateCode = contentjson['v08'];
      // }
      // if (contentjson['v10']) {
      //   this.userdata.mbSMSunTrstInd = contentjson['v10'];
      // }
      // if (contentjson['v19']) {
      //   this.userdata.mbSMAmexInd = contentjson['v19'];
      // }
      // if (contentjson['v20']) {
      //   this.userdata.mbSkyclubMember = contentjson['v20'];
      // }
      // if (contentjson['v27']) {
      //   this.userdata.mbSMCustomer = contentjson['v27'];
      // }
      // if (contentjson['v29']) {
      //   this.userdata.mbIsLoggedIn = contentjson['v29'];
      // }
      // if (contentjson['v38']) {
      //   this.userdata.mbCampainOfferCode = contentjson['v38'];
      // }
      if (contentjson['v39']) {
        this.userdata.ckLangCode = contentjson['v39'];
      }
      if (contentjson['v40']) {
        this.userdata.ckCountry = contentjson['v40'];
      }
      if (contentjson['statecode']) {
        this.userdata.closestAirportStateCode = contentjson['statecode'];
      }
      if (contentjson['airportcode']) {
        this.userdata.closestAirport = contentjson['airportcode'];
      }
      if (contentjson['isBusinessUser']) {
        this.userdata.isBusinessUser = contentjson['isBusinessUser'];
      }
      if (contentjson['isBusinessAccount']) {
        this.userdata.isBusinessAccount = contentjson['isBusinessAccount'];
      }
      if (contentjson['selectedCompany']) {
        this.userdata.selectedCompany = contentjson['selectedCompany'];
      }
      if (contentjson['isOaSmeAccount']) {
        this.userdata.isOaSmeAccount = contentjson['isOaSmeAccount'];
      }
      if (contentjson['crprtAgrmntTypeCode']) {
        this.userdata.crprtAgrmntTypeCode = contentjson['crprtAgrmntTypeCode'];
      }
      if (contentjson['contractMgtEnt']) {
        this.userdata.contractMgtEnt = contentjson['contractMgtEnt'];
      }
      if (contentjson['program']) {
        this.userdata.program = contentjson['program'];
      }
      if (contentjson['crprtAgrmntId']) {
        this.userdata.spid = contentjson['crprtAgrmntId'];
      }
      if (contentjson['isIntranetLink']) {
        this.userdata.isIntranetLink = contentjson['isIntranetLink'];
      }
      if (contentjson['milesExpiryDate']) {
        this.userdata.milesExpiryDate = new Date(
          contentjson['milesExpiryDate']
        );
      }
      if (contentjson['pageName']) {
        this.userdata.pageName = contentjson['pageName'];
      }
      if (contentjson['channelId']) {
        this.userdata.channelId = contentjson['channelId'];
      }
    }
  }

  populateRequestParam(campainId: any[], format: string) {
    // changed campainID type for getMultiplePEcall
    if (this.requestparam === null || this.requestparam === undefined) {
      this.requestparam = new RequestParam();
    }
    if (campainId) {
      this.requestparam.campaignId = campainId;
    }
    if (format) {
      this.requestparam.format = format;
    }
  }

  populateUserDataWithDataBroker(contentjson?: any) {
    for (const key in contentjson) {
      if (key !== undefined) {
        this.userdata[key] = contentjson[key];
      }
    }
  }
}

export class UserData {
  public MQMBalance: number;
  public authenticated: boolean;
  public cartCnt: string;
  public cartID: string;
  public country: string;
  public crprtAgrmntFound: boolean;
  public customerID: string;
  public displayPwdWarning: boolean;
  public enrollmentDate: string;
  public milesExpiryDate: Date;
  public errorCd: string;
  public firstName: string;
  public firstTime: boolean;
  public formNameSubmitted: string;
  public hasEmail: boolean;
  public hasError: boolean;
  public hasPW: boolean;
  public hasSQA: boolean;
  public hasUserNm: boolean;
  public irop: boolean;
  public is360Tier: boolean;
  public langPromptIndicator: boolean;
  public language: string;
  public lastName: string;
  public loggedIn: boolean;
  public loyaltyPromoInd: string;
  public loyaltyPromoLink: string;
  public medallionMbrInd: string;
  public medallionMemberDesc: string;
  public membershipLevel: string;
  public middleName: string;
  public millionMiler: boolean;
  public millionMilerTier: string;
  public nameSuffix: string;
  public preferredName: string;
  public prefix: string;
  public primaryEmailAddress: string;
  public promoCdInd: boolean;
  public pwmMbr: boolean;
  public rememberMeFirstName: string;
  public rememberMeID: string;
  public rememberMeIndicator: boolean;
  public rememberMeLastName: string;
  public skyPriority: string;
  public skymilesMember: boolean;
  public smBalance: number;
  public smNumber: string;
  public spgInd: boolean;
  public sysDrvdPrefHomeArptCd: string;
  public usernameType: string;
  public usrProvdPrefHomeArptCd: string;
  public venderID: string;
  public closestAirport: string;
  public closestAirportStateCode: string;
  public mbDerivedHomeAirportCode: string;
  public mbCountryCode: string;
  public mbActionIndicator: string;
  public mbSMTireLevel: string;
  public mbStateCode: string;
  public mbSMSunTrstInd: string;
  public mbSMAmexInd: string;
  public mbSkyclubMember: string;
  public mbSMCustomer: string;
  public mbIsLoggedIn: string;
  public mbCampainOfferCode: string;
  public ckLangCode: string;
  public ckCountry: string;
  public isBusinessUser: boolean;
  public isBusinessAccount: boolean;
  public selectedCompany: string;
  public isOaSmeAccount: boolean;
  public crprtAgrmntTypeCode: string;
  public contractMgtEnt: string;
  public spid: string;
  public program: string;
  public isIntranetLink: boolean;
  public pageName: string;
  public channelId: string;
}

export class RequestParam {
  public campaignId: any[];
  public format: string;
}

export class PEUserData {
  public devicetype: string;
  public language: string;
  public country: string;
  public mkcpgnValue: string;
  public tripType: string;
  public origin: string;
  public destination: string;
  public shopType: string;
  public isloggedIn: boolean;
  public noofpassengers: string;
  public meetingEventCode: string;
  public flexAirport: boolean;
  public flexDate: boolean;
  public refundableFlightsOnly: boolean;
}

export class SearchPERequest {
  public userdata: PEUserData;
  public requestparam: RequestParam;

  populateRequestParam(campainId: string, format: string) {
    if (this.requestparam === null || this.requestparam === undefined) {
      this.requestparam = new RequestParam();
    }
    if (campainId) {
      this.requestparam.campaignId = [campainId];
    }
    if (format) {
      this.requestparam.format = format;
    }
  }

  populateUserData(
    devicetype: string,
    language: string,
    country: string,
    mkcpgnValue: string,
    tripType: string,
    origin: string,
    destination: string,
    shopType: string,
    isloggedIn: boolean,
    noofpassengers: string,
    meetingEventCode: string,
    flexAirport: boolean,
    flexDate: boolean,
    refundableFlightsOnly: boolean
  ) {
    if (this.userdata === null || this.userdata === undefined) {
      this.userdata = new PEUserData();
    }

    if (devicetype) {
      this.userdata.devicetype = devicetype;
    }
    if (language) {
      this.userdata.language = language;
    }
    if (country) {
      this.userdata.country = country;
    }
    if (mkcpgnValue) {
      this.userdata.mkcpgnValue = mkcpgnValue;
    }
    if (tripType) {
      this.userdata.tripType = tripType;
    }
    if (origin) {
      this.userdata.origin = origin;
    }
    if (destination) {
      this.userdata.destination = destination;
    }
    if (shopType) {
      this.userdata.shopType = shopType;
    }
    if (noofpassengers) {
      this.userdata.noofpassengers = noofpassengers;
    }

    if (meetingEventCode) {
      this.userdata.meetingEventCode = meetingEventCode;
    }

    // For boolean value
    this.userdata.isloggedIn = isloggedIn;
    this.userdata.flexAirport = flexAirport;
    this.userdata.flexDate = flexDate;
    this.userdata.refundableFlightsOnly = refundableFlightsOnly;
  }
}
